<template>
  <svg
    width="210"
    height="137"
    viewBox="0 0 210 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="14.5"
      y="0.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="0.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#9333EA"
    />
    <rect
      x="22"
      y="8"
      width="24"
      height="24"
      rx="2"
      fill="#F4F0FA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.1235 23.9995C38.6067 23.9995 38.9985 23.6077 38.9985 23.1245V16.875C38.9985 16.3918 38.6068 16 38.1235 16H29.875C29.3918 16 29 16.3918 29 16.875V23.1245C29.0001 23.6077 29.3918 23.9995 29.875 23.9995H38.1235ZM37.3934 16.75H30.6052L33.9297 18.9834C33.9718 19.0116 34.0268 19.0116 34.0688 18.9834L37.3934 16.75ZM29.75 17.0785V23.1245C29.7501 23.1935 29.806 23.2495 29.875 23.2495H38.1235C38.1925 23.2495 38.2485 23.1935 38.2485 23.1245V17.0785L34.4873 19.606C34.1922 19.8042 33.8063 19.8042 33.5112 19.606L29.75 17.0785Z"
      fill="#9333EA"
    />
    <rect
      x="54"
      y="10"
      width="104"
      height="8"
      rx="2"
      fill="#F4F0FA"
    />
    <rect
      x="54"
      y="22"
      width="52"
      height="8"
      rx="2"
      fill="#F4F0FA"
    />
    <rect
      x="14.5"
      y="48.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="48.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#E7E5E4"
    />
    <path
      d="M22 59.0334C22 57.3581 23.3581 56 25.0334 56H42.9666C44.6419 56 46 57.3581 46 59.0334V76.9666C46 78.6419 44.6419 80 42.9666 80H25.0334C23.3581 80 22 78.6419 22 76.9666V59.0334Z"
      fill="#F5F5F4"
    />
    <path
      d="M38.2329 63.0793C38.5115 63.0251 38.7592 63.2961 38.6606 63.5773L35.5425 72.4514C35.4356 72.7534 35.0251 72.7953 34.8599 72.5207L32.7495 69.0041L29.2339 66.8947C28.9592 66.7295 29.0011 66.3189 29.3032 66.2121L38.1772 63.0939L38.2329 63.0793ZM33.3149 68.841L35.1392 71.882L37.7729 64.383L33.3149 68.841ZM29.8716 66.6144L32.9126 68.4387L37.3726 63.9787L29.8716 66.6144Z"
      fill="#505050"
    />
    <rect
      x="54"
      y="58"
      width="104"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="54"
      y="70"
      width="52"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="14.5"
      y="96.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="96.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#E7E5E4"
    />
    <path
      d="M22 107.033C22 105.358 23.3581 104 25.0334 104H42.9666C44.6419 104 46 105.358 46 107.033V124.967C46 126.642 44.6419 128 42.9666 128H25.0334C23.3581 128 22 126.642 22 124.967V107.033Z"
      fill="#F5F5F4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34 114.7C34.7179 114.7 35.3002 115.282 35.3003 116C35.3003 116.718 34.7179 117.3 34 117.3C33.2821 117.3 32.7002 116.718 32.7002 116C32.7003 115.282 33.2822 114.7 34 114.7ZM34 115.45C33.6964 115.45 33.4503 115.696 33.4502 116C33.4502 116.304 33.6964 116.55 34 116.55C34.3037 116.55 34.5503 116.304 34.5503 116C34.5502 115.696 34.3037 115.45 34 115.45Z"
      fill="#505050"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34 112.85C35.7397 112.85 37.1503 114.26 37.1504 116C37.1504 117.74 35.7397 119.15 34 119.15C32.2604 119.15 30.8501 117.74 30.8501 116C30.8502 114.26 32.2604 112.85 34 112.85ZM34 113.6C32.6746 113.6 31.6002 114.675 31.6001 116C31.6001 117.325 32.6746 118.4 34 118.4C35.3255 118.4 36.4004 117.325 36.4004 116C36.4003 114.675 35.3254 113.6 34 113.6Z"
      fill="#505050"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34 111C36.7615 111 39.0004 113.239 39.0005 116C39.0005 118.762 36.7615 121 34 121C31.2386 121 29 118.761 29 116C29.0001 113.239 31.2386 111 34 111ZM34 111.75C31.6528 111.75 29.7501 113.653 29.75 116C29.75 118.347 31.6528 120.25 34 120.25C36.3473 120.25 38.2505 118.347 38.2505 116C38.2504 113.653 36.3472 111.75 34 111.75Z"
      fill="#505050"
    />
    <rect
      x="54"
      y="106"
      width="104"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="54"
      y="118"
      width="52"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      y="49"
      width="210"
      height="88"
      fill="url(#paint0_linear_3534_24601)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3534_24601"
        x1="105"
        y1="49"
        x2="105"
        y2="137"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="white"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
</script>
